import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { reactFormatter } from 'react-tabulator';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest,deleteRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,EditRowIcon,PaperClipIcon,EditIcon,DeleteIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { LocaleContext } from '../../../components/LocaleContext';
import { DateTime } from "luxon";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from 'primereact/checkbox';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { createArrayNavigateHandlers } from '../../../utils/arrayNavigate';
import { emitOtkCompanyListMutation } from '../../../utils/otkCompanyListSync';

export default function OtkCompanyCertificateAdd({otk_company, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview} = useContext(UtilContext);
  const { t } = useContext(LocaleContext);
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const submitRef = useRef(null);
    const [formOtkCompanyCertificate,setformOtkCompanyCertificate] = useState(otk_company);
    const [formType, setFormType] = useState(type);
    const [showOtkCertificateAdd, setShowOtkCertificateAdd] = useState(false);

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({name:true,description:true});
    //id:true,calibration_company_id:true,custom_start_of_validity:true,custom_end_of_validity:true,description:true,protocol:true,state:true,
    const [maskVisible, setMaskVisible] = useState(false);
//TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("edit otk-company"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit otk-company"))?false:true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    
    const [selectedCertificate,setSelectedCertificate] = useState(null);

    const [visibleCompanyCertificate,setVisibleCompanyCertificate] = useState(false);

    const [images,setImages] = useState('');

    const [fileList, setFileList] = useState([]);
    const fileListRef = useRef(null);

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);

    const STATUS_ACTIVE = 'active';
    const STATUS_EXCLUDED = 'excluded';
    const [partnerStatusByType, setPartnerStatusByType] = useState(() => {
        const by = otk_company?.partner_status_by_type || {};
        return {
            customer: by.customer === STATUS_EXCLUDED ? STATUS_EXCLUDED : STATUS_ACTIVE,
            supplier: by.supplier === STATUS_EXCLUDED ? STATUS_EXCLUDED : STATUS_ACTIVE,
        };
    });
    const [savingPartnerStatus, setSavingPartnerStatus] = useState(false);
    const [visibleExcludeConfirm, setVisibleExcludeConfirm] = useState(false);
    const [visibleActivateConfirm, setVisibleActivateConfirm] = useState(false);
    const [excludeCertificatesToo, setExcludeCertificatesToo] = useState(false);
    const [excludeCertificatesDate, setExcludeCertificatesDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [activateCertificatesToo, setActivateCertificatesToo] = useState(false);
    const [pendingSaveCloseAfter, setPendingSaveCloseAfter] = useState(false);

    useEffect(() => {
        const by = otk_company?.partner_status_by_type || {};
        setPartnerStatusByType({
            customer: by.customer === STATUS_EXCLUDED ? STATUS_EXCLUDED : STATUS_ACTIVE,
            supplier: by.supplier === STATUS_EXCLUDED ? STATUS_EXCLUDED : STATUS_ACTIVE,
        });
    }, [otk_company?.id, otk_company?.partner_status_by_type]);

    const handlePartnerStatusChange = (key, value) => {
        setPartnerStatusByType(prev => ({ ...prev, [key]: value }));
    };

    const prevStatus = otk_company?.partner_status_by_type || {};
    const isChangingToExcluded = (partnerStatusByType.customer === STATUS_EXCLUDED && prevStatus.customer !== STATUS_EXCLUDED) ||
        (partnerStatusByType.supplier === STATUS_EXCLUDED && prevStatus.supplier !== STATUS_EXCLUDED);
    const isChangingToActive = (partnerStatusByType.customer === STATUS_ACTIVE && prevStatus.customer === STATUS_EXCLUDED) ||
        (partnerStatusByType.supplier === STATUS_ACTIVE && prevStatus.supplier === STATUS_EXCLUDED);

    const doSavePartnerStatus = (closeAfter = false, opts = {}) => {
        if (!otk_company?.id) return;
        setSavingPartnerStatus(true);
        const formData = new FormData();
        formData.append('partner_status_by_type', JSON.stringify(partnerStatusByType));
        if (opts.deactivateCertificates && opts.deactivationDate) {
            formData.append('deactivate_certificates', '1');
            formData.append('deactivation_date', opts.deactivationDate);
        }
        if (opts.activateCertificates) {
            formData.append('activate_certificates', '1');
        }
        setDialogText(t('Common.Saving'));
        setVisible(true);
        postRequest(`/api/companies/update/${otk_company.id}`, formData, true)
            .then((saveRes) => Promise.all([
                Promise.resolve(saveRes),
                getRequest('/api/companies'),
                getRequest('/api/company_certificates'),
            ]))
            .then(([saveRes, companiesRes, certsRes]) => {
                dispatch({ type: 'load_companies', newCompanies: companiesRes.data });
                setOtkCertificates(certsRes?.data ?? []);
                const saved = saveRes?.data?.data ?? saveRes?.data ?? null;
                const row = (saved && saved.id != null)
                    ? saved
                    : ((Array.isArray(companiesRes?.data) ? companiesRes.data : []).find((c) => String(c?.id) === String(otk_company.id)) || null);
                const prevAt = otk_company?.updated_at;
                const nextAt = row?.updated_at;
                const unchanged = prevAt != null && nextAt != null && String(prevAt) === String(nextAt)
                    && !opts.deactivateCertificates && !opts.activateCertificates;
                if (unchanged) {
                    emitOtkCompanyListMutation({
                        operation: 'noop',
                        id: otk_company.id,
                        row,
                        changedFields: [],
                    });
                } else {
                    const changedFields = ['partner_status_by_type', 'company_status_display', 'partner_status_display', 'validity'];
                    if (opts.deactivateCertificates) changedFields.push('deactivate_certificates', 'certificates');
                    if (opts.activateCertificates) changedFields.push('activate_certificates', 'certificates');
                    emitOtkCompanyListMutation({
                        operation: 'update',
                        id: otk_company.id,
                        row,
                        changedFields,
                    });
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('OtkCompanyCertificateAdd.Toast.PartnerStatusSaved') });
                if (closeAfter) dispatch({ type: 'close_tab', id: state.selectedTab });
            })
            .catch((reason) => {
                console.error(reason);
                toast?.current?.show({ severity: 'error', summary: t('Common.Error'), life: 3000, detail: t('OtkCompanyCertificateAdd.Toast.SaveFailed') });
            })
            .finally(() => {
                setVisible(false);
                setSavingPartnerStatus(false);
                setVisibleExcludeConfirm(false);
                setVisibleActivateConfirm(false);
                setPendingSaveCloseAfter(false);
            });
    };

    const handleSavePartnerStatus = (closeAfter = false) => {
        if (!otk_company?.id) return;
        if (isChangingToExcluded) {
            setPendingSaveCloseAfter(closeAfter);
            setVisibleExcludeConfirm(true);
            return;
        }
        if (isChangingToActive) {
            setPendingSaveCloseAfter(closeAfter);
            setVisibleActivateConfirm(true);
            return;
        }
        doSavePartnerStatus(closeAfter);
    };

    const onConfirmExclude = () => {
        doSavePartnerStatus(pendingSaveCloseAfter, {
            deactivateCertificates: excludeCertificatesToo,
            deactivationDate: excludeCertificatesToo ? excludeCertificatesDate : undefined,
        });
    };

    const onConfirmActivate = () => {
        doSavePartnerStatus(pendingSaveCloseAfter, {
            activateCertificates: activateCertificatesToo,
        });
    };

    function addNewOtkCompanyCertificate(){
        setShowOtkCertificateAdd(true);
      }
      
    function copyOtkCompanyCertificate(){
        const row = getTable()?.getSelectedData?.()?.[0];
        if (row) formik.setValues(row);
        setShowOtkCertificateAdd(true); 
    }

    function editNewOtkCompanyCertificate(){
    const row = getTable()?.getSelectedData?.()?.[0];
    if (row) formikUpdate.setValues(row);
    setVisibleCompanyCertificate(true);
    }


    function hideEditOtkCompanyCertificate(){
        formikUpdate.resetForm();
        setVisibleCompanyCertificate(false);
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
            initialValues:{
                name:'',description:'',type:'otk'},
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                let formData = new FormData();
                for (let value in values) {
                    formData.append(value, values[value]);
                }
                formData.append("company_id", otk_company.id);
                setDialogText(t('Common.Saving'));
                setVisible(true);
                    postRequest('/api/company_certificates', formData,true)
                    .then((response) => {
                        setVisible(false);
                        console.log(response);
                        emitOtkCompanyListMutation({
                            operation: 'update',
                            id: otk_company.id,
                            row: null,
                            changedFields: ['certificates'],
                        });
                        getRequest("/api/company_certificates").then((response) => {
                            getRequest('/api/company_certificates/paged?type=otk&size=500&page=1').then((r) => setOtkCertificates(r?.data ?? []));
                            if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                            if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                            setShowOtkCertificateAdd(false);
                            formik.resetForm();
                            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                        });
                        getRequest("/api/companies").then((response) => {
                            dispatch({type:'load_companies',newCompanies:response.data});
                        });
                    }).catch((reason) => {
                        setVisible(false);
                        if(!navigator.online){
                            alert(t('ServiceTask.OfflineQueuedAlert'));
                        }
                        else{
                            alert(t('Common.Toast.ActionFailedDetail'));
                        }
                    })
            },
        });
    
        const formikUpdate = useFormik({
            initialValues: selectedCertificate == null ? {
                name:'',description:'',type:'otk'} : selectedCertificate,
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                let formData = new FormData();
                delete values.files;
                for (let value in values) {
                    formData.append(value, values[value] != null ? values[value] : "");
                }
                formData.append("company_id",  otk_company.id);
                setDialogText(t('Common.Saving'));
                setVisible(true);
                postRequest(`/api/company_certificates/update/${formikUpdate.values.id}`, formData,true)
                .then((response) => {
                    setVisible(false);
                    emitOtkCompanyListMutation({
                        operation: 'update',
                        id: otk_company.id,
                        row: null,
                        changedFields: ['certificates'],
                    });
                    getRequest("/api/company_certificates").then((response) => {
                        getRequest('/api/company_certificates/paged?type=otk&size=500&page=1').then((r) => setOtkCertificates(r?.data ?? []));
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        setVisibleCompanyCertificate(false);
                        formikUpdate.resetForm();
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                    getRequest("/api/companies").then((response) => {
                        dispatch({type:'load_companies',newCompanies:response.data});
                    });
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                });
            },
        });

    const [otkCertificates, setOtkCertificates] = useState([]);
    useEffect(() => {
        getRequest('/api/company_certificates/paged?type=otk&size=500&page=1')
            .then((r) => setOtkCertificates(r?.data ?? []))
            .catch(() => setOtkCertificates([]));
    }, []);
    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(otkCertificates, formik.values.id, setformOtkCompanyCertificate),
        [otkCertificates, formik.values.id]
    );

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        const selected = getTable()?.getSelectedData?.() ?? [];
        if(selected.length === 1){
            if(user.permissions?.includes("edit otk-company"))setEditIcon(false);
            if(user.permissions?.includes("delete otk-company"))setDeleteIcon(false);
            if(user.permissions?.includes("edit otk-company"))setCopyIcon(false);
            setSelectedCertificate(selected[0]);
        }
    }

      function onEditRow(otk_company){
        formikUpdate.setValues(otk_company);
        setSelectedCertificate(otk_company);
        setVisibleCompanyCertificate(true);      
    };

    function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
    }  

    const [columns,setColumns] = useState([
      { title: '', field: 'id',formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center",width: 20,headerSort:false,resizable:false},
      { title: '', field: 'editor',hozAlign:"center",width: 20,headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
      { title: t('Common.Name'), field: 'name',headerFilter:"input",minWidth: 200, widthGrow:1},
      { title: t('Common.Description'), field: 'description',headerFilter:"input",minWidth: 200, widthGrow:1},
    ]);

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
       columnVisible[item] = value;
       console.log(columnVisible);
        const t = getTable();
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            t?.hideColumn?.(val);
          }
          else{
            t?.showColumn?.(val);
          }
        }
        setColumnsVisible(columnVisible);
      }
function changeMarkings(value){
        const t = getTable();
        if(value){
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="id" || columnVisible[val]!=="editor" || columnVisible[val]!=="end_of_validity"){
              columnVisible[val]=true;
              t?.showColumn?.(val);
            }
          };
          setColumnsVisible(columnVisible);
        }
        else{
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"|| columnVisible[val]!=="end_of_validity"){
              columnVisible[val]=false;
              t?.hideColumn?.(val);
            }
          };
          setColumnsVisible(columnVisible);
        }
      }

      const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
      }

    const acceptCertificate = () => {
            setDialogText(t('Common.DeletingShort'));
            setVisible(true);
            const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
            var itemsProcessed = 0;
            const total = rows_to_delete.length;
            rows_to_delete.forEach((item) => {
              deleteRequest(`/api/company_certificates/${item.id}`)
                  .then((response) => {
                    itemsProcessed++;
                    emitOtkCompanyListMutation({
                      operation: 'update',
                      id: otk_company.id,
                      row: null,
                      changedFields: ['certificates'],
                    });
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                    getRequest("/api/company_certificates").then((response) => {
                      getRequest('/api/company_certificates/paged?type=otk&size=500&page=1').then((r) => setOtkCertificates(r?.data ?? []));
                    });
                    if (itemsProcessed === total) {
                        setVisible(false);
                        getRequest("/api/companies").then((response) => {
                            dispatch({type:'load_companies',newCompanies:response.data});
                        });
                    }
                  }).catch((reason) => {
                      setVisible(false);
                      alert(reason);
                      toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
                  })
            });
        }

      const confirm = () => {
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteRecord'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCertificate
        });
    };

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={insertCopyIcon || savingPartnerStatus} onClick={() => { handleSavePartnerStatus(true); }}><SaveAndCloseIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="save"><button className="disabled:opacity-25" disabled={insertCopyIcon || savingPartnerStatus} onClick={() => handleSavePartnerStatus()}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewOtkCompanyCertificate()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyOtkCompanyCertificate()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button onClick={() => openFavoriteDialog(t('Otk.EditTrainingCompanyCerts'),"OtkCompanyCertificateAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("OtkCompanyCertificateAdd",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          </IntersectionObserverWrapper>
        </div>
        <div className="w-full relative flex flex-col min-h-[calc(100vh_-_177px)] overflow-x overflow-y-auto px-4 py-4">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   KARTA PARTNERA
                </h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('BusinessPartnerAdd.Label.Name')}</label>
                        <input
                        readOnly={true}
                            name='name'
                            type="text"
                            value={otk_company.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                        readOnly={true}
                            name='tel_number'
                            type="text"
                            value={otk_company?.tel_number}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                        readOnly={true}
                            name='email'
                            type="text"
                            value={otk_company?.email}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                        readOnly={true}
                            name='contact_person'
                            type="text"
                            value={otk_company?.contact_person}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='address'
                            type="text"
                            value={otk_company?.address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                        readOnly={true}
                            name='fax'
                            type="text"
                            value={otk_company?.fax}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='web_address'
                            type="text"
                            value={otk_company?.web_address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                        readOnly={true}
                            name='gauge_name'
                            type="text"
                            value={otk_company?.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
                        <div className="mt-4 pt-4 border-t border-gray-300">
                            <h3 className="text-md font-semibold text-gray-800 mb-3">{t('QualityPartnerList.Column.PartnerStatus')}</h3>
                            {otk_company?.types?.includes?.('customer') && (
                                <div className="mb-3">
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">{t('Common.Customer')}</label>
                                    <select
                                        value={partnerStatusByType.customer}
                                        onChange={(e) => handlePartnerStatusChange('customer', e.target.value)}
                                        className="block w-full px-3 py-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring"
                                    >
                                        <option value={STATUS_ACTIVE}>{t('Common.Active')}</option>
                                        <option value={STATUS_EXCLUDED}>{t('Status.Deactivated')}</option>
                                    </select>
                                </div>
                            )}
                            {otk_company?.types?.includes?.('supplier') && (
                                <div className="mb-3">
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">{t('Common.Supplier')}</label>
                                    <select
                                        value={partnerStatusByType.supplier}
                                        onChange={(e) => handlePartnerStatusChange('supplier', e.target.value)}
                                        className="block w-full px-3 py-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring"
                                    >
                                        <option value={STATUS_ACTIVE}>{t('Common.Active')}</option>
                                        <option value={STATUS_EXCLUDED}>{t('Status.Deactivated')}</option>
                                    </select>
                                </div>
                            )}
                            </div>
            </div> 
            </div>
            </div>
            </div>
            <Dialog header={t('Otk.AddDocumentation')} visible={showOtkCertificateAdd} style={{ width: '40vw' }} onHide={() => setShowOtkCertificateAdd(false)}>
            <form onSubmit={formik.handleSubmit}>
            <div>
                <div> 
                    <label
                        htmlFor="name"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.Name')}</label>
                    <input
                        name='name'
                        type="text"
                        onChange={formik.handleChange} value={formik.values.name}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div> 
                    <label 
                    htmlFor='description'
                    className='font-bold text-black'>{t('Common.Description')}</label>
                    <input 
                    name='description'
                    type='text'
                    onChange={formik.handleChange} value={formik.values.description}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.SaveState')}</button>         
            </form>
            </Dialog>
            <Dialog header={t('Otk.EditDocumentation')} visible={visibleCompanyCertificate} style={{ width: '40vw' }} onHide={() => hideEditOtkCompanyCertificate()}>
    <form onSubmit={formikUpdate.handleSubmit}>
    <div>
                <div> 
                <label
                    htmlFor="name"
                    className="block text-md font-semibold text-gray-800"
                >{t('Common.Name')}</label>
                <input
                    name='name'
                    type="text"
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.name}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
                </div>
                <div> 
                    <label 
                    htmlFor='description'
                    className='font-bold text-black'>{t('Common.Description')}</label>
                    <input 
                    name='description'
                    type='text'
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.SaveState')}</button>         
            </form>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2 || index>6) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("OtkCompanyCertificateAdd","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
<Dialog header={t('Otk.DecommissionPartner')} visible={visibleExcludeConfirm} style={{ width: '420px' }} onHide={() => { setVisibleExcludeConfirm(false); setPendingSaveCloseAfter(false); }} footer={
            <div className="flex gap-2 justify-end">
              <button type="button" onClick={() => { setVisibleExcludeConfirm(false); setPendingSaveCloseAfter(false); }} className="px-3 py-2 border border-zinc-400 rounded hover:bg-zinc-100">{t('Common.Cancel')}</button>
              <button type="button" onClick={onConfirmExclude} className="px-3 py-2 bg-zinc-800 text-white rounded hover:bg-zinc-700">{t('Ui.R67.Ano_vyradit')}</button>
            </div>
          }>
            <p className="mb-4">{t('Ui.R67.Naozaj_chcete_vyradit_obchodneho_partnera')}</p>
            <div className="flex align-items-center gap-2 mb-2">
              <Checkbox inputId="excludeCerts" checked={excludeCertificatesToo} onChange={(e) => setExcludeCertificatesToo(e.checked)} />
              <label htmlFor="excludeCerts">{t('Ui.R67.Deaktivovat_aj_dokumentacie_k_danemu_obch_partnerovi')}</label>
            </div>
            {excludeCertificatesToo && (
              <div className="ml-6 mt-2">
                <label htmlFor="excludeCertDate" className="block text-sm font-semibold text-gray-700 mb-1">{t('Ui.R67.Datum_deaktivacie')}</label>
                <input id="excludeCertDate" type="date" value={excludeCertificatesDate} onChange={(e) => setExcludeCertificatesDate(e.target.value)} className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:border-gray-400 focus:ring focus:ring-gray-200" />
              </div>
            )}
          </Dialog>

          <Dialog header={t('Otk.ActivatePartner')} visible={visibleActivateConfirm} style={{ width: '420px' }} onHide={() => { setVisibleActivateConfirm(false); setPendingSaveCloseAfter(false); }} footer={
            <div className="flex gap-2 justify-end">
              <button type="button" onClick={() => { setVisibleActivateConfirm(false); setPendingSaveCloseAfter(false); }} className="px-3 py-2 border border-zinc-400 rounded hover:bg-zinc-100">{t('Common.Cancel')}</button>
              <button type="button" onClick={onConfirmActivate} className="px-3 py-2 bg-zinc-800 text-white rounded hover:bg-zinc-700">{t('Common.Yes')}</button>
            </div>
          }>
            <p className="mb-4">{t('Ui.R67.Chcete_aktivovat_deaktivovane_dokumentacie_u_daneho_obch_par')}</p>
            <div className="flex align-items-center gap-2">
              <Checkbox inputId="activateCerts" checked={activateCertificatesToo} onChange={(e) => setActivateCertificatesToo(e.checked)} />
              <label htmlFor="activateCerts">{t('Ui.R67.Ano_aktivovat_deaktivovane_dokumentacie')}</label>
            </div>
          </Dialog>
            </> 
            );
} 
